import { ReactNode } from 'react'
import { STATUS_ICONS } from '@/lib/constants/icons.tsx'
import { ProjectsStatusT } from '@/routes/settings/projects/lib/projectsTypes.ts'
import { IconNameT } from '@/components/common/Icon.tsx'

export default function getProjectStatusIcon(status: ProjectsStatusT | undefined): {
  icon: ReactNode
  iconName: IconNameT
} {
  let icon: ReactNode
  let iconName: IconNameT
  switch (status) {
    case 'IN_PROGRESS':
      icon = STATUS_ICONS['inProgress']
      iconName = 'inProgress'
      break
    case 'COMPLETED':
      icon = STATUS_ICONS['abandoned']
      iconName = 'abandoned'

      break
    case 'PLANNED':
      icon = STATUS_ICONS['reported']
      iconName = 'reported'
      break
    case 'ON_HOLD':
      icon = STATUS_ICONS['onHold']
      iconName = 'onHold'
      break
    default:
      icon = STATUS_ICONS['done']
      iconName = 'done'
  }

  return { icon, iconName }
}
